<div class="viewContainer">
    <h4 class="blueHeader">{{ "STATISTICS" | translate }}</h4>
    <div class="row mt-3">
        <div class="col-12 tabs-col">
            <!--Tab selects-->
            <span class="cursorPointer" [class.tabDisabled]="loadingPdf || pngExport.captureInProgress" [ngClass]="selectedTab === 'alerts' ? 'darkUnderline' : 'defaultUnderline'" (click)="selectTab('alerts')">
                <span class="tabLabel" [ngClass]="{ highlightedLabel: selectedTab === 'alerts'}">
                    {{ "ALERTS_TAB" | translate}}
                </span>
            </span>

            <ng-container *ngIf="EMAACEnabled">
                <span class="defaultUnderline cursorDefault">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

                <span class="cursorPointer" [class.tabDisabled]="loadingPdf || pngExport.captureInProgress" [ngClass]=" selectedTab === 'alarmCenter' ? 'darkUnderline' : 'defaultUnderline'" (click)="selectTab('alarmCenter')">
                    <span class="tabLabel" [ngClass]="{ highlightedLabel: selectedTab === 'alarmCenter' }">
                        {{ "ALARM_CENTER" | translate }}
                    </span>
                </span>
            </ng-container>

            <span class="defaultUnderline cursorDefault">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

            <span class="cursorPointer" [class.tabDisabled]="loadingPdf || pngExport.captureInProgress" [ngClass]="selectedTab === 'careRecipients' ? 'darkUnderline' : 'defaultUnderline'" (click)="selectTab('careRecipients')">
                <span class="tabLabel" [ngClass]="{ highlightedLabel: selectedTab === 'careRecipients'}">
                    {{ "CARE_RECIPIENTS" | translate }}
                </span>
            </span>
            <span class="defaultUnderline cursorDefault">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

            <span class="cursorPointer" [class.tabDisabled]="loadingPdf || pngExport.captureInProgress" [ngClass]="selectedTab === 'activeUsers' ? 'darkUnderline' : 'defaultUnderline'" (click)="selectTab('activeUsers')">
                <span class="tabLabel" [ngClass]="{ highlightedLabel: selectedTab === 'activeUsers'}">
                    {{ "ACTIVE_USERS" | translate }}
                </span>
            </span>
        </div>
    </div>

    <div class="blueCard mt-3">
        <div class="workflow-steps">

            <!-- ── Settings ─────────────────────────────────────────────── -->
            <div class="step-box">
                <!-- Time section -->
                <div class="settings-section mb-2">
                    <h6 class="settings-heading">{{ "TIME_TEXT" | translate }}</h6>
                    <div class="time-controls">
                        <div id="timeFilterSelectContainer" *ngIf="dateOptions">
                            <button #dropdownBtn class="selectDropdownBtn dropdown-toggle" (click)="showTimeOptions = true">
                                <i class="fa-regular fa-calendar-range fa-lg"></i>
                                <p>{{ selectedDateOptionText }}</p>
                            </button>
                            <div *ngIf="showTimeOptions" class="customDropdown" #dropdownMenu>
                                <div class="dropdownOption" (click)="onDateSelect(dateOptions.today)">{{ dateOptions.today.text }}</div>
                                <div class="dropdownOption" (click)="onDateSelect(dateOptions.yesterday)">{{ dateOptions.yesterday.text }}</div>
                                <div class="dropdownOption" (click)="onDateSelect(dateOptions.lastWeek)">{{ dateOptions.lastWeek.text }}</div>
                                <div class="dropdownOption" (click)="onDateSelect(dateOptions.lastMonth)">{{ dateOptions.lastMonth.text }}</div>
                                <div class="dropdownOption" (click)="onDateSelect(dateOptions.last90Days)">{{ dateOptions.last90Days.text }}</div>
                                <div class="dropdownOption" (click)="onDateSelect(dateOptions.custom)">{{ dateOptions.custom.text }}...</div>
                            </div>
                        </div>

                        <ng-container *ngIf="selectedDateOption === 'custom'">
                            <div class="datePickerContainer">
                                <small class="dateLabel">{{ "REPORT_START_DATE" | translate }}</small>
                                <mat-form-field appearance="outline" class="customDateSelect">
                                    <input matInput [max]="currentDate" [matDatepicker]="filterStartDatePicker"
                                        [ngModel]="statistics.filters.startDate" #startDateInput="ngModel"
                                        (dateChange)="onCustomStartDateSelect($event)" />
                                    <mat-datepicker-toggle matSuffix class="customDatePicker" [for]="filterStartDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #filterStartDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="datePickerContainer">
                                <small class="dateLabel">{{ "REPORT_END_DATE" | translate }}</small>
                                <mat-form-field appearance="outline" class="customDateSelect">
                                    <input matInput [min]="dateLimit" [max]="currentDate"
                                        [matDatepicker]="filterEndDayPicker"
                                        [ngModel]="statistics.filters.endDate" #endDateInput="ngModel"
                                        (dateChange)="onCustomEndDateSelect($event)" />
                                    <mat-datepicker-toggle matSuffix class="customDatePicker" [for]="filterEndDayPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #filterEndDayPicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="datePickerContainer">
                                <small class="dateLabel">{{ "START_TIME" | translate }}</small>
                                <mat-form-field appearance="outline" class="customDateSelect">
                                    <input matInput type="time" [(ngModel)]="startTime" (change)="onTimeChange()" name="startTimeFilter" />
                                </mat-form-field>
                            </div>
                            <div class="datePickerContainer" [class.time-invalid]="endTimeConflict">
                                <small class="dateLabel">{{ "END_TIME" | translate }}</small>
                                <mat-form-field appearance="outline" class="customDateSelect">
                                    <input matInput type="time" [(ngModel)]="endTime" (change)="onTimeChange()" name="endTimeFilter" />
                                </mat-form-field>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Filters section -->
                <div class="settings-section">
                    <h6 class="settings-heading">{{ "FILTERS" | translate }}</h6>
                    <div class="filters-dropdowns">
                        <div class="form-group" *ngIf="filterSelects.location.filterList" [hidden]="['alarmCenter'].includes(selectedTab)">
                            <ngx-bootstrap-multiselect
                                [options]="filterSelects.location.filterList"
                                [settings]="filterSelects.settings"
                                [texts]="filterSelects.location.texts"
                                [(ngModel)]="statistics.filters.locations"
                                name="locationsFilter">
                            </ngx-bootstrap-multiselect>
                        </div>

                        <div class="form-group" *ngIf="filterSelects.device.filterList" [hidden]="['activeUsers'].includes(selectedTab)">
                            <ngx-bootstrap-multiselect
                                [options]="filterSelects.device.filterList"
                                [settings]="filterSelects.settings"
                                [texts]="filterSelects.device.texts"
                                [(ngModel)]="statistics.filters.devices"
                                name="devicesFilter">
                            </ngx-bootstrap-multiselect>
                        </div>

                        <div class="form-group" *ngIf="filterSelects.deviceTypes.filterList" [hidden]="['activeUsers'].includes(selectedTab)">
                            <ngx-bootstrap-multiselect
                                (ngModelChange)="onDeviceTypeFilterChange($event)"
                                [options]="filterSelects.deviceTypes.filterList"
                                [settings]="filterSelects.settings"
                                [texts]="filterSelects.deviceTypes.texts"
                                [(ngModel)]="statistics.filters.deviceTypes"
                                name="deviceTypesFilter">
                            </ngx-bootstrap-multiselect>
                        </div>

                        <div class="form-group" *ngIf="filterSelects.activations.filterList && statistics.filters.deviceTypes.length > 0">
                            <ngx-bootstrap-multiselect
                                [options]="filterSelects.activations.filterList"
                                [settings]="filterSelects.settings"
                                [texts]="filterSelects.activations.texts"
                                [(ngModel)]="statistics.filters.alertTypes"
                                name="alertTypesFilter">
                            </ngx-bootstrap-multiselect>
                        </div>

                        <div class="form-group" *ngIf="filterSelects.alertRoute.filterList" [hidden]="['activeUsers'].includes(selectedTab)">
                            <ngx-bootstrap-multiselect
                                [options]="filterSelects.alertRoute.filterList"
                                [settings]="filterSelects.settings"
                                [texts]="filterSelects.alertRoute.texts"
                                [(ngModel)]="statistics.filters.alertRoutes"
                                name="alertRoutesFilter">
                            </ngx-bootstrap-multiselect>
                        </div>

                        <div class="form-group" *ngIf="filterSelects.personnel.filterList" [hidden]="['alarmCenter'].includes(selectedTab)">
                            <ngx-bootstrap-multiselect
                                [options]="filterSelects.personnel.filterList"
                                [settings]="filterSelects.settings"
                                [texts]="filterSelects.personnel.texts"
                                [(ngModel)]="statistics.filters.personnels"
                                name="personnelsFilter">
                            </ngx-bootstrap-multiselect>
                        </div>

                        <button id="resetBtn" type="button" class="btn" *ngIf="hasActiveFilters" (click)="resetFilters()">
                            <span class="fa-light fa-xmark mr-1"></span>{{ "CLEAR_FILTERS" | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- ── Actions row: Search left, Export right ─────────────── -->
            <div class="actions-row">
                <div class="step-box">
                    <button class="btn statisticsBtn"
                            [ngClass]="(filtersChangedSinceSearch || !isExportReady()) ? 'btn-primary' : 'btn-outline-secondary'"
                            (click)="onSearchTabData()"
                            [disabled]="loadingPdf || loadingData || endTimeConflict || startDateInput?.invalid || endDateInput?.invalid">
                        <span class="fa-light fa-search mr-1"></span>{{ "SEARCH" | translate }}
                    </button>
                </div>

                <div class="step-box step-box--export">
                    <mat-accordion>
                        <mat-expansion-panel class="mb-2" [disabled]="loadingPdf || loadingData || !isExportReady()">
                            <mat-expansion-panel-header>
                                <div>
                                    <span class="fa-light fa-download mr-2"></span>
                                    {{ "EXPORT_TO" | translate }}&nbsp;&nbsp;
                                </div>
                            </mat-expansion-panel-header>
                            <div class="form-inline">
                                <button
                                    class="btn btn-primary btn-block"
                                    (click)="exportPdf()"
                                    [disabled]="loadingPdf">
                                    <span *ngIf="loadingPdf; else pdfLabel">{{ 'LOADING_PDF' | translate }}...</span>
                                    <ng-template #pdfLabel>
                                        <span *ngIf="pdfError; else pdfText">{{ 'PDF_RETRY' | translate }}</span>
                                        <ng-template #pdfText>PDF</ng-template>
                                    </ng-template>
                                </button>
                                <button
                                    class="btn btn-outline-primary btn-block"
                                    (click)="exportJSON()"
                                    [disabled]="loadingPdf">
                                    JSON
                                </button>
                                <p class="pdf-export-status text-success mb-0 mt-1" *ngIf="pdfSuccess">
                                    PDF ✓
                                </p>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>

        </div>
    </div>

    <div class="pdf-export-progress-panel" *ngIf="loadingPdf" role="status" aria-live="polite">
        <mat-progress-bar
            mode="determinate"
            color="primary"
            [value]="pdfExportProgress"
        ></mat-progress-bar>
        <p class="pdf-export-progress-label mb-0">
            {{ pdfExportStatusKey | translate }} ({{ pdfExportProgress }}%)
        </p>
    </div>

    <div class="mt-4 pb-4" [class.pdf-export-capture-sandbox]="loadingPdf">
        <!-- Once a tab has loaded, keep it mounted with [hidden] so revisiting
             it uses cached data without re-running ngOnInit or re-fetching. -->
        <alerts-tab
            *ngIf="selectedTab === 'alerts' || statistics.isTabDataLoaded('alerts')"
            [hidden]="selectedTab !== 'alerts'">
        </alerts-tab>
        <alarm-center-tab
            *ngIf="selectedTab === 'alarmCenter' || statistics.isTabDataLoaded('alarmCenter')"
            [hidden]="selectedTab !== 'alarmCenter'">
        </alarm-center-tab>
        <care-recipients-tab
            *ngIf="selectedTab === 'careRecipients' || statistics.isTabDataLoaded('careRecipients')"
            [hidden]="selectedTab !== 'careRecipients'">
        </care-recipients-tab>
        <active-users-tab
            *ngIf="selectedTab === 'activeUsers' || statistics.isTabDataLoaded('activeUsers')"
            [hidden]="selectedTab !== 'activeUsers'">
        </active-users-tab>
    </div>
</div>
